import React from "react";
import './styles.css';
import Photo from "./Photo";
import FirstAnimatedContainer from "./FirstAnimatedContainer";

function Header ({title, photoUrl}){
    return(
        <FirstAnimatedContainer animationDuration="1s">
        <div className="header">
          <Photo url={photoUrl} />
          <h1>{title}</h1>
        </div>
      </FirstAnimatedContainer>
    )
}

export default Header;